import { render, staticRenderFns } from "./EventResult.vue?vue&type=template&id=59ca6b3f"
import script from "./EventResult.vue?vue&type=script&lang=js"
export * from "./EventResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports